export function IconButton({ children, className = '', ...props }) {
  return (
    <button type="button" className={`traffix-icon-btn ${className}`} {...props}>
      {children}
    </button>
  );
}

export function EmptyState({ children }) {
  return <div className="traffix-empty">{children}</div>;
}

export function Drawer({ open, title, subtitle, onClose, children, className = '', busy = false }) {
  if (!open) return null;
  return (
    <div className={`traffix-drawer ${className}`}>
      <div className="traffix-drawer-h">
        <div>
          {title ? <h3>{title}</h3> : null}
          {subtitle ? <span>{subtitle}</span> : null}
        </div>
        {onClose ? <IconButton aria-label="Chiudi" disabled={busy} onClick={onClose}>×</IconButton> : null}
      </div>
      <div className="traffix-drawer-b">{children}</div>
    </div>
  );
}

export function SideCard({ children, className = '' }) {
  return (
    <div className={`traffix-side-card-container ${className}`}>
      <div className="traffix-side-card">{children}</div>
    </div>
  );
}

export function FormGrid({ children }) {
  return <div className="traffix-form-grid">{children}</div>;
}

export function KpiChip({ children, className = '' }) {
  return <div className={`traffix-kpi-item ${className}`}>{children}</div>;
}

export function PageShell({ children, className = '' }) {
  return <div className={`traffix-page-shell ${className}`}>{children}</div>;
}

export function IframeShell({ src, title, visible = true, onLoad, children }) {
  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100vh',
        zIndex: visible ? 99999 : -1,
        opacity: visible ? 1 : 0,
        pointerEvents: visible ? 'auto' : 'none',
      }}
    >
      <iframe src={src} title={title} style={{ width: '100%', height: '100%', border: 'none' }} onLoad={onLoad} />
      {children}
    </div>
  );
}
